export enum TagFilteringStyle {
  PILLS = 'Pills',
  CHECKBOXES = 'Checkboxes',
  COLORED_CHECKBOXES = 'Colored Checkboxes',
  ABBREVIATIONS = 'Abbreviations',
  HIDE = 'Hide',
}
